import { QueryClientProvider } from '@tanstack/react-query'
import type { ReactNode } from 'react'
import { queryClient } from './queryClient'
import { AuthProvider } from '../features/auth/AuthProvider'
import { ToastProvider } from '../components/feedback/Toast'

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider><ToastProvider>{children}</ToastProvider></AuthProvider>
    </QueryClientProvider>
  )
}
